import { render, staticRenderFns } from "./display-field-payment-reminder.vue?vue&type=template&id=c7a608aa&scoped=true&"
import script from "./display-field-payment-reminder.vue?vue&type=script&lang=ts&"
export * from "./display-field-payment-reminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a608aa",
  null
  
)

export default component.exports